import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import SectionCard from './SectionCard';
import SettingRow from './SettingRow';
import StatusPill from './StatusPill';
import settingsStyles from '../settingsStyles';
import BookingInfoImport from '../../../Content/GeneralInformation/components/BookingInfoImport';

// Booking.com'dan otel bilgisi / fotograf / olanak / oda tipi aktarimi.
// Islem ve modal mevcut BookingInfoImport bileseninden gelir; burada yalnizca
// satir gorunumu ve "daha once aktarildi" durumu eklenir.
export default function ImportCard() {
    const {t} = useTranslation();
    const classes = settingsStyles();

    const checkData = useSelector((state) => state.bookingImportReducer?.checkData);
    const alreadyImported = checkData && checkData.status === 200 && !checkData.error
        && checkData.data && checkData.data.imported === true;

    return (
        <SectionCard
            id="aktarim"
            icon="fas fa-cloud-download-alt"
            title={t('enw-web-settings-import_title', 'İçe Aktarım')}
            description={t('enw-web-settings-import_desc', "Otel bilgilerinizi Booking.com'dan tek seferde çekin")}
        >
            <SettingRow
                icon="fas fa-cloud-download-alt"
                title={t('enw-web-settings-booking_import_title', "Booking.com'dan İçe Aktar")}
                badge={alreadyImported
                    ? <StatusPill tone="ok" label={t('enw-web-settings-imported', 'Aktarıldı')} />
                    : null}
                active={!!alreadyImported}
                description={alreadyImported
                    ? t('enw-web-settings-booking_import_done', 'Otel bilgileri, açıklama, fotoğraflar, olanaklar ve oda tipleri Booking.com kaydınızdan alındı.')
                    : t('enw-web-settings-booking_import_desc', 'Booking.com Hotel ID girerek otel bilgilerini, fotoğrafları, olanakları ve oda tiplerini otomatik doldurun.')}
                control={
                    <BookingInfoImport
                        alwaysShowButton
                        skipProfileFetch
                        buttonClassName={classes.btn}
                        buttonIcon={<i className={alreadyImported ? 'fas fa-sync-alt' : 'fas fa-cloud-download-alt'} />}
                        buttonLabel={alreadyImported
                            ? t('enw-web-settings-import_again', 'Yeniden Aktar')
                            : t('enw-web-settings-import_now', 'İçe Aktar')}
                    />
                }
            >
                {alreadyImported && (
                    <p className={classes.hint}>
                        {t('enw-web-settings-booking_import_hint', 'Yeniden aktarım mevcut içeriğin üzerine yazar; elle düzenlediğiniz açıklamalar kaybolabilir.')}
                    </p>
                )}
            </SettingRow>
        </SectionCard>
    );
}
